import React from 'react';
import { useSearchParams } from 'react-router-dom';
import useNavigationPaths from './useNavigationPaths.hook';
import { SecuredOperation } from '@/@types/validateToken';
import { useValidateToken } from '@/apiHooks/validateToken.hook';
import { setSessionStorageItem } from '@/utils/session';

export const useValidateOperationToken = () => {
  const { validateToken } = useValidateToken();
  const { clearNestedPath, nestedPath } = useNavigationPaths();
  const [searchParams, setSearchParams] = useSearchParams();

  const validateOperationToken = React.useCallback(
    (token: string, operation: SecuredOperation) => {
      validateToken(
        { token: token, operation: operation },
        {
          onSuccess: (response) => {
            searchParams.delete('token');
            setSearchParams(searchParams);

            if (operation === SecuredOperation.LEGACY_KEY_AND_LEGAL) {
              setSessionStorageItem('isSessionEntitledForKeyAndLegal', response?.valid);
              if (!response?.valid) {
                clearNestedPath();
              }
            }

            if (operation === SecuredOperation.LEGACY_TENANT_PROTECTION) {
              setSessionStorageItem('isSessionEntitledForTenantProtection', response?.valid);
              if (!response?.valid) {
                clearNestedPath();
              }
            }
          },
          onError: (err) => {
            searchParams.delete('token');
            setSearchParams(searchParams);
          },
        },
      );
    },
    [nestedPath],
  );

  return { validateOperationToken };
};
